import React, { useState, useEffect } from 'react';
import Skeleton from '../OtherElements/CustomSkeleton';
import axios from '../../api/axios';
import Select from 'react-select';
import FormHelperText from '@material-ui/core/FormHelperText';

const SelectPackage = ({ pack, onSelect, disabled, error = false }) => {
  const [packages, setPackage] = useState(null);
  disabled === undefined && (disabled = false);
  const load = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/packaging/type/list`);
      !!data && setPackage(data);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleSelect = (option) => {
    const pack = packages.find((p) => p._id === option.value);
    onSelect(pack);
  };

  useEffect(() => {
    load();
  }, []);
  return (
    <>
      {!!packages ? (
        <div>
          <Select
            options={packages.map((pack) => ({
              label: pack.title,
              value: pack._id,
            }))}
            isMulti={false}
            isSearchable={true}
            placeholder="بسته بندی"
            value={!!pack ? { label: pack.title, value: pack._id } : null}
            onChange={(pack) => handleSelect(pack)}
            noOptionsMessage={() => 'بسته بندی یافت نشد.'}
            isDisabled={disabled}
            styles={{
              menu: (provided, state) => ({
                ...provided,
                zIndex: 2,
              }),
            }}
          />
          {error ? <FormHelperText error>{error}</FormHelperText> : null}
        </div>
      ) : (
        <Skeleton height={50} />
      )}
    </>
  );
};

export default SelectPackage;
